import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
var Description = styled.p.withConfig({
  displayName: "AffiliationBlockTypeSlideshowstyle__Description",
  componentId: "sc-p7x9pg-0"
})(["margin-top:", ";text-align:center;"], getSpacing(1));
var InputContainer = styled.div.withConfig({
  displayName: "AffiliationBlockTypeSlideshowstyle__InputContainer",
  componentId: "sc-p7x9pg-1"
})(["width:100%;margin-top:", ";"], getSpacing(1));
var ButtonContainer = styled.div.withConfig({
  displayName: "AffiliationBlockTypeSlideshowstyle__ButtonContainer",
  componentId: "sc-p7x9pg-2"
})(["display:flex;justify-content:center;margin-top:", ";column-gap:10px;"], getSpacing(2));
var LoaderContainer = styled.div.withConfig({
  displayName: "AffiliationBlockTypeSlideshowstyle__LoaderContainer",
  componentId: "sc-p7x9pg-3"
})(["display:flex;justify-content:center;width:500px;height:140px;margin:", ";"], getSpacing(1));
var InputTitle = styled.div.withConfig({
  displayName: "AffiliationBlockTypeSlideshowstyle__InputTitle",
  componentId: "sc-p7x9pg-4"
})(["align-self:flex-start;margin-top:", ";font-weight:bold;"], getSpacing(3));
export { ButtonContainer, Description, InputContainer, InputTitle, LoaderContainer };